import patio1 from "@/assets/images/services/patio1.jpg";
import phoneBox from "@/assets/images/services/phone-boxe.jpg";
import rooftop1 from "@/assets/images/services/rooftop1.jpg";
import rooftop2 from "@/assets/images/services/rooftop2.jpg";
import cafetRDC2 from "@/assets/images/services/cafet-RDC2.jpg";
import cafetRDC3 from "@/assets/images/services/cafet-RDC3.jpg";
import cafetRDC4 from "@/assets/images/services/cafet-RDC4.jpg";
import cafetRDC5 from "@/assets/images/services/cafet-RDC5.jpg";
import cafetEntree from "@/assets/images/services/cafet-entree.jpg";
import phoneBox3em from "@/assets/images/services/3em-boxe.jpg";
import balconTerrasse5em from "@/assets/images/services/5em-balcon-terrasse.jpg";
import phoneBox5em from "@/assets/images/services/5em-boxe.jpg";
import terrasse6em from "@/assets/images/services/6em-terrasse.jpg";
import cafet2em1 from "@/assets/images/services/cafet-2em1.jpg";
import cafet2em2 from "@/assets/images/services/cafet-2em2.jpg";
import grandeSalleReunion from "@/assets/images/services/grande-salle-reu1.jpg";
import salleReuPatio from "@/assets/images/services/salle-reu-patio.jpg";
import SalleReuRue from "@/assets/images/services/salle-reu-rue.jpg";
import Terrasse2em from "@/assets/images/services/terrasse-2em.jpg";

// Export all images in an array for use in the carousel
export const servicesImages = [
  patio1,
  rooftop1,
  rooftop2,
  cafetRDC2,
  cafetRDC3,
  cafetRDC4,
  cafetRDC5,
  cafetEntree,
  phoneBox3em,
  phoneBox,
  balconTerrasse5em,
  phoneBox5em,
  terrasse6em,
  cafet2em1,
  cafet2em2,
  grandeSalleReunion,
  salleReuPatio,
  SalleReuRue,
  Terrasse2em,
];
